import login from '@/componentes/login'
import recargar from '@/componentes/recargas'
import recargasMasivas from '@/componentes/recargasMasivas'
import administrar from '@/componentes/administrarBase'
import registrar from '@/componentes/usuarios'
import usuarioNew from '@/componentes/usuarioNew'
import actualizacionesDetalle from '@/componentes/actualizacionesDetalle'
import actualizaciones from '@/componentes/actualizaciones'
// import listUsers from '@/componentes/listUsers'
import listUsers from '@/componentes/listUsers'
import saldos from '@/componentes/saldos'
import ventas from '@/componentes/ventas'
import subir from '@/componentes/subirArchivos'
import nav from '@/componentes/navbar'
import sinEmpresa from '@/componentes/sinEmpresa'
import configuraciones from '@/componentes/configuraciones'
import graficas from '@/componentes/graficas'
import recicladoMasivo from '@/componentes/recicladoMasivo'
import portabilidades from '@/componentes/portabilidades'
import inventario from '@/componentes/inventoryDays'
import recargasCarier from '@/componentes/recargasCarier'
import comentariosCarier from '@/componentes/comentariosCarier'
import nuevoUsuarioPlataforma from '@/componentes/nuevoUsuarioPlataforma'
import recargasUsuario from '@/componentes/recargasUsuario'
import configRecargasSinUsuario from '@/componentes/configRecargasSinUsuario'
import sesionInvalida from '@/componentes/sesionInvalida'

const rutas = [
  {path: '/', component: sinEmpresa, name: 'sinEmpresa'},
  {path: '/:empresa', component: login, name: 'login'},
  {path: '/:empresa/sesionInvalida', component: sesionInvalida, name: 'sesionInvalida'},
  {path: '/:empresa/recargasUsuario', component: recargasUsuario, name: 'recargasUsuario'},
  {path:'/in', component:nav, children:[
      {path:'/in/recargas', component: recargar, name: 'recargas'},
      {path:'/in/recargasMasivas', component: recargasMasivas, name: 'recargasMasivas'},
      {path:'/in/usuarios', component: listUsers, name: 'usuarios'},
      {path:'/in/usuarioNew', component: usuarioNew, name: 'addUsuario'},
      {path:'/in/editarUsuario/:id', component: usuarioNew, name: 'editarUsuario'},
      // {path:'/in/usuarios', component: registrar, name: 'usuarios'},
      {path:'/in/saldos', component: saldos, name: 'saldos'},
      {path:'/in/ventas', component: ventas, name: 'ventas'},
      {path:'/in/subirArchivos', component: subir, name: 'subirArchivos'},
      {path:'/in/administrarBase', component: administrar, name: 'administrarBase'},
      {path:'/in/configuraciones', component: configuraciones, name: 'configuraciones'},
      {path:'/in/graficas', component: graficas, name: 'graficas'},
      {path:'/in/grarecicladoMasivo', component: recicladoMasivo, name: 'recicladoMasivo'},
      {path:'/in/portabilidades', component: portabilidades, name: 'portabilidades'},
      {path:'/in/inventario', component: inventario, name: 'inventario'},
      {path:'/in/recargasCarier', component: recargasCarier, name: 'recargasCarier'},
      {path:'/in/comentariosCarier', component: comentariosCarier, name: 'comentariosCarier'},
      {path:'/in/configRecargasSinUsuario', component: configRecargasSinUsuario, name: 'configRecargasSinUsuario'},
      {path:'/in/nuevoUsuarioPlataforma', component: nuevoUsuarioPlataforma, name: 'nuevoUsuarioPlataforma'},
      {path:'/in/actualizaciones', component: actualizaciones, name: 'actualizaciones'},
      {path:'/in/actualizaciones/:id', component: actualizacionesDetalle, name: 'actualizacionesDetalle'}
    ]}

]

export default rutas

